module.exports = __webpack_public_path__ + "img/unhappy.dc554a5f.png";